import React, { useState } from 'react'
import * as PropTypes from 'prop-types'
import './ExternalVisitForm.scss'

const ExternalVisitForm = props => {
  const [numberOfBargeVisits, setNumberOfBargeVisits] = useState(1)
  return (
    <div className="external-visit-form">
      <p>How many barge visits do you wish to create?</p>
      <input
        type="number"
        value={numberOfBargeVisits}
        onChange={e => {
          setNumberOfBargeVisits(Number(e.target.value))
        }}
      />
      <button
        className="save-btn btn valid"
        onClick={e => {
          e.preventDefault()
          props.createExternalVisitBargeVisits(props.terminalVisit, numberOfBargeVisits)
        }}
      >
        Create Visits
      </button>
    </div>
  )
}

export default ExternalVisitForm

ExternalVisitForm.propTypes = {
  terminalVisit: PropTypes.object.isRequired, // terminal visit object
  createExternalVisitBargeVisits: PropTypes.func.isRequired // Params: terminalVisit: TerminalVisit, numberOfBargeVisits: number
}
